import { ThunkAction } from 'redux-thunk';

import { RiskJudge, riskJudge } from '../services/contractApi';
export { RiskJudge } from '../services/contractApi';

/**
 * リスク判定用モジュール
 */
export interface RiskJudgeState {
  riskJudge: RiskJudge | null;
  messages: string[];
  status: number;
}

const initialState: RiskJudgeState = {
  riskJudge: null,
  messages: [],
  status: 0,
};

const REQUEST_RISKJUDGE = 'REQUEST_RISKJUDGE';
type REQUEST_RISKJUDGE = typeof REQUEST_RISKJUDGE;

const RECEIVE_RISKJUDGE = 'RECEIVE_RISKJUDGE';
type RECEIVE_RISKJUDGE = typeof RECEIVE_RISKJUDGE;

const FAIL_RISKJUDGE = 'FAIL_RISKJUDGE';
type FAIL_RISKJUDGE = typeof FAIL_RISKJUDGE;

const CLEAR_RISKJUDGE = 'CLEAR_RISKJUDGE';
type CLEAR_RISKJUDGE = typeof CLEAR_RISKJUDGE;

const CLEAR_RISKJUDGE_MESSAGES = 'CLEAR_RISKJUDGE_MESSAGES';
type CLEAR_RISKJUDGE_MESSAGES = typeof CLEAR_RISKJUDGE_MESSAGES;

interface RequestRiskJudge {
  type: REQUEST_RISKJUDGE;
}

interface ReceiveRiskJudge {
  type: RECEIVE_RISKJUDGE;
  riskJudge: RiskJudge;
}

interface FailRiskJudge {
  type: FAIL_RISKJUDGE;
  messages: string[];
  status: number;
}

interface ClearRiskJudge {
  type: CLEAR_RISKJUDGE;
}

interface ClearRiskJudgeMessages {
  type: CLEAR_RISKJUDGE_MESSAGES;
}

export type RiskJudgeAction =
  | RequestRiskJudge
  | ReceiveRiskJudge
  | FailRiskJudge
  | ClearRiskJudge
  | ClearRiskJudgeMessages;

type RiskJudgeDocuments = ThunkAction<
  void,
  RiskJudgeState,
  undefined,
  RiskJudgeAction
>;

export function requestRiskJudge(): RequestRiskJudge {
  return {
    type: REQUEST_RISKJUDGE,
  };
}

export function receiveRiskJudge(riskJudge: RiskJudge): ReceiveRiskJudge {
  return {
    riskJudge,
    type: RECEIVE_RISKJUDGE,
  };
}

export function failRiskJudge(messages: string[], status: number): FailRiskJudge {
  return {
    messages,
    status,
    type: FAIL_RISKJUDGE,
  };
}

export function clearRiskJudge(): ClearRiskJudge {
  return {
    type: CLEAR_RISKJUDGE,
  };
}

export function clearRiskJudgeMessages(): ClearRiskJudgeMessages {
  return {
    type: CLEAR_RISKJUDGE_MESSAGES,
  };
}

export function postRiskJudge(id: number): RiskJudgeDocuments {
  return (dispatch) => {
    dispatch(requestRiskJudge());
    riskJudge(id).then((res) => {
      const { status, result, messages, status_code } = res;
      if (status === 200 && result) {
        dispatch(receiveRiskJudge(result));
      } else {
        dispatch(failRiskJudge(messages, status_code));
      }
    }).catch((err) => {
      dispatch(failRiskJudge([String(err)], 500));
    });
  };
}

export default function reducer(
  state: RiskJudgeState | undefined,
  action: RiskJudgeAction,
): RiskJudgeState {
  if (!state) return initialState;
  switch (action.type) {
    case REQUEST_RISKJUDGE: {
      return state;
    }
    case RECEIVE_RISKJUDGE: {
      const { riskJudge } = action;
      return { riskJudge, messages: [], status: 0 };
    }
    case FAIL_RISKJUDGE: {
      const { messages, status } = action;
      return { ...state, messages, status };
    }
    case CLEAR_RISKJUDGE: {
      return initialState;
    }
    case CLEAR_RISKJUDGE_MESSAGES: {
      return { ...state, messages: [] };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/riskJudge.ts